import { useLocation } from 'react-router-dom';

const Redirect = () => {
  const location = useLocation();
  window.location.replace(`https://launch.goflink.com${location.pathname}`);
  return <></>;
};

export default Redirect;
